module.exports = __webpack_public_path__ + "img/productActive-2.1fe202bb.svg";